var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C7.35954 1.12686 5.78681 1.77935 4.62683 2.93933C3.46685 4.09931 2.81436 5.67204 2.8125 7.3125C2.8125 12.607 8.4375 16.6057 8.67727 16.773C8.77184 16.8393 8.88452 16.8748 9 16.8748C9.11548 16.8748 9.22816 16.8393 9.32273 16.773C9.5625 16.6057 15.1875 12.607 15.1875 7.3125C15.1856 5.67204 14.5331 4.09931 13.3732 2.93933C12.2132 1.77935 10.6405 1.12686 9 1.125ZM9 5.0625C9.44501 5.0625 9.88002 5.19446 10.25 5.44169C10.62 5.68893 10.9084 6.04033 11.0787 6.45146C11.249 6.8626 11.2936 7.315 11.2068 7.75145C11.12 8.18791 10.9057 8.58882 10.591 8.90349C10.2763 9.21816 9.87541 9.43245 9.43895 9.51927C9.0025 9.60608 8.5501 9.56153 8.13896 9.39123C7.72783 9.22093 7.37643 8.93254 7.12919 8.56253C6.88196 8.19252 6.75 7.75751 6.75 7.3125C6.75 6.71576 6.98705 6.14347 7.40901 5.72151C7.83097 5.29955 8.40326 5.0625 9 5.0625Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.124f49208325ad34c2775c1053a59e8e.svg";
export { ForwardRef as ReactComponent };